import React from 'react'
import styled from 'styled-components'

const StyledCopyright = styled.div`
  color: ${props => props.color};
  font-family: 'Roboto';
  font-size: ${props => props.fontSize};
  text-align: center;
  font-weight: 300;
  margin: 0 auto;
  margin-top: 25px;
  line-height: 1.5;
`
const Copyright = props =>
  <StyledCopyright {...props}>
    A product of <br /> Square Direct Communication Group ® <br />Version 4.0
  </StyledCopyright>

Copyright.propTypes = {}
Copyright.defaultProps = {
  color: '#eee',
  fontSize: '12px'
}

export default Copyright



// WEBPACK FOOTER //
// ./src/components/Copyright/index.js